export default {"src":"/_next/static/media/heart_64.bda91493.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};